<template>
  <div class="modal-box">
    <div class="modal-title">
      <h3>Updates</h3>
      <div class="flex-divider"></div>
      <base-button type="secondary" @click="markAsRead">
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div
          class="change-wrapper"
          v-for="(change, index) in changes"
          :key="index"
        >
          <div class="change-title">
            <h3>{{ change.title }}</h3>
          </div>
          <div class="change-subtitle">
            <h4>{{ change.date }}</h4>
          </div>
          <div
            class="change"
            v-for="(block, index) in change.blocks"
            :key="index"
          >
            <p>{{ block.body }}</p>
            <ul>
              <li v-for="(item, index) in block.listItems" :key="index">
                <span class="bold">{{ item[0] }}</span
                ><br />
                {{ item[1] }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-divider"></div>
      <base-button @click="markAsRead">
        <base-icon iconRef="done-all" position="left" />Gelezen</base-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangelogModal",
  data() {
    return {
      changes: [
        {
          title: "Versie 1.2.2",
          date: "15-02-2021",
          version: "1.2.2",
          blocks: [
            {
              body: "",
              listItems: [
                [
                  "Expert-modus altijd aan",
                  "Als je een advies bekijkt staat vanaf nu standaard de expert-modus aan"
                ],
                [
                  "Nieuwe verdeling van 'hoorbare', 'goede' en 'optimale' akoestiek",
                  "Waar eerst de grenzen op 70, 80 en 95 lagen, zijn deze nu veranderd naar 60, 75 en 90. Hierdoor kunnen we makkelijker een incrementele verbetering adviseren, zonder dat we een 'onvoldoende' moeten adviseren. Hoorbare verbetering: 70 -> 60, Goede akoestiek: 80 -> 75, Optimale akoestiek: vanaf 95 -> vanaf 90."
                ]
              ]
            }
          ]
        },
        {
          title: "Versie 1.2.1",
          date: "14-09-2020",
          version: "1.2.1",
          blocks: [
            {
              body: "Een tweakje hier en een checkboxje daar...",
              listItems: [
                [
                  "De kleine letters",
                  "Fontgrootte in de klantenlijst iets verhoogd."
                ],
                [
                  "Mine!",
                  "Vinkje om alleen je eigen klanten te zien is terug."
                ],
                [
                  "Doet 'ie het echt?",
                  "Bug gefixed die ervoor zorgde dat sommige klantdata incompleet was, en niet in de lijst te vinden was."
                ]
              ]
            }
          ]
        },
        {
          title: "Versie 1.2.0",
          date: "07-09-2020",
          version: "1.2.0",
          blocks: [
            {
              body:
                "De complete data fetching en verwerking is herschreven, waardoor Sonar nu wél efficient met de data omgaat.",
              listItems: [
                [
                  "Fetchen",
                  "Sonar haalt niet meer tegelijk álle data op, maar alleen de data die je nodig hebt."
                ],
                [
                  "Verwerken",
                  "Ook het verwerken (updaten, verwijderen) van de data gaat efficienter. Dit zul je vooral merken in het opstellen van het advies."
                ],
                [
                  "Futureproof",
                  "De manier waarop Sonar nu met de data omgaat is volledig voorbereid op de toekomst. Het maakt nu niet meer uit hoeveel klanten er in Sonar staan, het systeem zal altijd even snel blijven."
                ]
              ]
            }
          ]
        },
        {
          title: "Versie 1.1.0",
          date: "25-06-2019",
          version: "1.1.0",
          blocks: [
            {
              body:
                "Scenario's dupliceren, klanten gesorteerd op datum en een terugknop.",
              listItems: [
                [
                  "Scenario's dupliceren",
                  "Je kunt nu scenario's gemakkelijk dupliceren, zoals dat bij de producten ook kan."
                ],
                [
                  "Klanten nu standaard gesorteerd op aanmaakdatum",
                  "Waar voorheen de klanten standaard waren gesorteerd op alfabetische volgorde, staan ze nu automatisch op volgorde van aanmaakdatum, met de nieuwste bovenaan."
                ],
                [
                  "Terugknop",
                  "Sonar heeft in de navigatiebalk nu een terugknop, deze werkt exact hetzelfde als de terugknop in de browser (chrome e.d.), en is ideaal voor mobiele gebruikers om snel terug te navigeren binnen Sonar."
                ]
              ]
            }
          ]
        },
        {
          title: "Versie 1.0.0",
          date: "29-04-2019",
          version: "1.0.0",
          blocks: [
            {
              body:
                "Daar is 'ie dan, de eerste officiële release van Sonar! 🎉",
              listItems: [
                [
                  "Nieuwe adviespagina",
                  "In plaats van dat je het advies direct onder de meting opstelt, is er nu een knop 'Advies opstellen' om naar de nieuwe uitgebreide adviespagina te gaan. Deze pagina biedt extra uitleg en zelfs een 'expert modus' om nog dieper op de gegevens in te gaan. (Voor de mooiste print, zet bij de printopties de schaal op maximaal 90%)"
                ],
                [
                  "Klanten sorteren op aanmaakdatum",
                  "In de klantenlijst kun je nu de datum zien waarop klanten zijn toegevoegd aan Sonar en daarop sorteren."
                ],
                [
                  "Montagechecklist",
                  "Hiermee kun je per project een aantal gegevens vaststellen m.b.t. levering en montage."
                ]
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    currentUser() {
      const currentUserUid = this.$store.getters.getUser.uid;
      const currentUser = this.$store.getters.getUsersList.find(
        user => user.data().uid == currentUserUid
      );
      return currentUser;
    }
  },
  methods: {
    markAsRead() {
      this.$firestore
        .collection("users")
        .doc(this.currentUser.id)
        .set({ lastReadUpdate: this.changes[0].date }, { merge: true })
        .then(() => {
          this.$store.dispatch("fetchUsers");
        });
      this.closeModal();
    },
    closeModal() {
      this.$store.commit("setModalShown", {
        dataType: "changelog",
        modalType: "view",
        shown: false
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/changelog-modal.vue